module.exports = __webpack_public_path__ + "static/media/0354_Small.932dd985.jpg";